var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 0.703857H1.72414C0.775862 0.703857 0 1.53039 0 2.54059V16.8671C0 17.8773 0.775862 18.7039 1.72414 18.7039H8.27586C9.22414 18.7039 10 17.8773 10 16.8671V2.54059C10 1.53039 9.22414 0.703857 8.27586 0.703857ZM4.94828 17.7304C4.48276 17.7304 4.08621 17.3263 4.08621 16.812C4.08621 16.3161 4.46552 15.8937 4.94828 15.8937C5.43103 15.8937 5.81034 16.2977 5.81034 16.812C5.81034 17.3263 5.41379 17.7304 4.94828 17.7304ZM8.62069 15.2141H1.37931V3.09161H8.62069V15.2141Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.31078098155363aac8de2f04d4a84465.svg";
export { ForwardRef as ReactComponent };